var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "password-input-container" },
    [
      _c("input", {
        staticClass: "w-100 border-0 input",
        attrs: {
          type: _vm.showPassword ? "text" : "password",
          placeholder: _vm.placeholder,
          id: "password",
          tabindex: _vm.tabindex,
          required: ""
        },
        domProps: { value: _vm.value },
        on: {
          input: function($event) {
            return _vm.$emit("input", $event.target.value)
          }
        }
      }),
      _vm._v(" "),
      _c("font-awesome-icon", {
        staticClass: "password-eye mx-2",
        attrs: { icon: _vm.showPassword ? "eye-slash" : "eye", size: "1x" },
        on: { click: _vm.toggleShowPassword }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03b98a6f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b98a6f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordInput.vue
// module id = null
// module chunks = 